export default __webpack_public_path__ + "static/media/minus_3(1).abf8a36d.png";